import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import s from './Faq.css';
import btn from '../shared/landingButtons.css';
import cs from '../../commonStyle.css';
import messages from '../../../locale/messages';
import Link from '../../Link';

const createFaqRichTextValues = () => {
  let key = 0;
  const nextKey = (tag) => `${tag}-${key++}`;

  return {
    p: (...chunks) => <p key={nextKey('p')}>{chunks}</p>,
    ul: (...chunks) => <ul key={nextKey('ul')} className={s.faqList}>{chunks}</ul>,
    li: (...chunks) => <li key={nextKey('li')}>{chunks}</li>,
    strong: (...chunks) => <strong key={nextKey('strong')}>{chunks}</strong>,
    h6: (...chunks) => <h6 key={nextKey('h6')}>{chunks}</h6>,
  };
};

const faqItems = [
  { question: messages.newLandingFaqQuestion1, answer: messages.newLandingFaqAnswer1 },
  { question: messages.newLandingFaqQuestion2, answer: messages.newLandingFaqAnswer2 },
  { question: messages.newLandingFaqQuestion3, answer: messages.newLandingFaqAnswer3 },
  { question: messages.newLandingFaqQuestion4, answer: messages.newLandingFaqAnswer4 },
  { question: messages.newLandingFaqQuestion5, answer: messages.newLandingFaqAnswer5 },
  { question: messages.newLandingFaqQuestion6, answer: messages.newLandingFaqAnswer6 },
  { question: messages.newLandingFaqQuestion7, answer: messages.newLandingFaqAnswer7 },
];

class Faq extends React.Component {
  state = {
    openIndexes: [],
    answersReady: false,
  };

  componentDidMount() {
    this.setState({ answersReady: true });
  }

  toggleItem = (index) => {
    this.setState((prev) => {
      const openIndexes = prev.openIndexes.includes(index)
        ? prev.openIndexes.filter((i) => i !== index)
        : [...prev.openIndexes, index];

      return { openIndexes };
    });
  };

  renderAnswer = (answer) => (
    <FormattedMessage {...answer} values={createFaqRichTextValues()} />
  );

  render() {
    const { openIndexes, answersReady } = this.state;

    return (
      <div className={s.faqSection}>
        <h3><FormattedMessage {...messages.newLandingFaqTitle} /></h3>

        {faqItems.map((item, index) => {
          const isOpen = openIndexes.includes(index);

          return (
            <div key={`${item.question.id}-${index}`} className={s.faqItem}>
              <button
                type="button"
                className={s.faqSummary}
                onClick={() => this.toggleItem(index)}
                aria-expanded={isOpen}
              >
                <FormattedMessage {...item.question} />
              </button>
              <div
                className={cx(s.faqContent, isOpen && s.faqContentOpen)}
                aria-hidden={!isOpen}
              >
                {answersReady && this.renderAnswer(item.answer)}
              </div>
            </div>
          );
        })}

        <div className={s.faqBtnContainer}>
          <Link to="/s" className={cx(btn.landingBtn, btn.landingBtnDark, s.faqCta)}>
            <FormattedMessage {...messages.newLandingBookNow} />
          </Link>
        </div>
      </div>
    );
  }
}

export default withStyles(s, btn, cs)(Faq);
